import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import CustomCursor from './components/CustomCursor'
import ParticlesBackground from './components/ParticlesBackground'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import ProgramsPage from './pages/ProgramsPage'
import TeamPage from './pages/TeamPage'
import GetInvolvedPage from './pages/GetInvolvedPage'
import PartnersPage from './pages/PartnersPage'

function App() {
    return (
        <div className="min-h-screen flex flex-col font-sans">
            <ParticlesBackground />
            <CustomCursor />
            <ScrollToTop />
            <Header />
            <main className="flex-1">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/programs" element={<ProgramsPage />} />
                    <Route path="/team" element={<TeamPage />} />
                    <Route path="/get-involved" element={<GetInvolvedPage />} />
                    <Route path="/partners" element={<PartnersPage />} />
                </Routes>
            </main>
            <Footer />
        </div>
    )
}

export default App
